/**
 * @param {Object} obj
 * @return {Boolean}
 */
const hasKeys = obj => Object.keys(obj).length > 0;

export { hasKeys };
